import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TextAreaField } from "../fields/TextAreaField";

type Props = {
  label: string;
  helperText?: string;
  labelIcon?: React.ReactNode;
  name: string;
} & React.ClassAttributes<HTMLTextAreaElement> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextAreaInput = ({ name, onChange, ...rest }: Props) => {
  const { control, register, getFieldState, formState } = useFormContext();

  const { ref, onChange: hookOnChange, ...hookFormProps } = register(name);

  const customOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  const value =
    useWatch({
      name,
      control,
    }) || "";

  return (
    <TextAreaField
      errorMessage={getFieldState(name, formState).error?.message}
      value={value}
      innerRef={ref}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
